export default {"src":"/_next/static/media/Location.bf601965.svg","height":21,"width":18};